import { type ResultOf } from '@graphql-typed-document-node/core'
import { type TFunction } from 'i18next'

import { graphql } from '~/gql'

import { CustomerAttributeOp } from '../modelOperators'

const customerAttributeGroupFragment = graphql(`
  fragment FigureInfoHelpers_ToCustomerAttributeTexts_CustomerAttributeGroup on CustomerAttributeGroup {
    name
    customerAttributes {
      id
      name
    }
  }
`)
type CustomerAttributeGroup = ResultOf<typeof customerAttributeGroupFragment>

/**
 * 顧客属性の ID の配列から、顧客属性のテキストの配列を作成します。
 *
 * @param customerAttributeIds - 顧客属性の ID の配列。
 * @param customerAttributeGroups - 顧客属性グループの配列。
 * @param t - 多言語化関数。
 * @returns 顧客属性のテキストの配列。
 *
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export function toCustomerAttributeTexts(
  customerAttributeIds: string[],
  customerAttributeGroups: CustomerAttributeGroup[],
  t: TFunction,
): string[] {
  return customerAttributeIds.map((customerAttributeId) => {
    const { customerAttributeGroupName, customerAttributeName } =
      CustomerAttributeOp.getNameFromGroups(
        customerAttributeGroups,
        customerAttributeId,
        t,
      )

    return `[${customerAttributeGroupName}] ${customerAttributeName}`
  })
}
